import { render, staticRenderFns } from "./ChangeRoleModal.vue?vue&type=template&id=e6839fa6&scoped=true&"
import script from "./ChangeRoleModal.vue?vue&type=script&lang=js&"
export * from "./ChangeRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRoleModal.vue?vue&type=style&index=0&id=e6839fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6839fa6",
  null
  
)

component.options.__file = "ChangeRoleModal.vue"
export default component.exports